import * as angular from 'angular';
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import ChangePasswordServiceName, {ChangePasswordData, ChangePasswordService}
  from "../../services/changePassword/changePassword.service";
import template from './changeUserPassword.tpl.html';

let requires = [LoaderServiceName, NotifyServiceName, ChangePasswordServiceName];

interface ChangePasswordController {
  form: angular.IFormController;

  userProfile: apsViewModels.UserProfileData;

  oldPassword: string;
  newPassword: string;
  confirmPassword: string;

  changePassword(): void;
  close(): void;
}

export function openChangeUserPassword(data: apsViewModels.UserProfileData,
                                       $modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'UserChangePasswordCtrl as vm',
    resolve: {
      data: function () {
        return data;
      }
    }
  }).result;
}

export default angular.module('aps.controller.changeUserPassword', requires)
  .controller('UserChangePasswordCtrl', userChangePasswordCtrl)
  .name;

function userChangePasswordCtrl(
 $modalInstance: mm.foundation.modalInstance,
 loaderService: LoaderService,
 notifyService: NotifyService,
 changePwdService: ChangePasswordService,
 data: apsViewModels.UserProfileData
): ChangePasswordController {

  let vm = this as ChangePasswordController;

  vm.userProfile = data;

  vm.oldPassword = '';
  vm.newPassword = '';
  vm.confirmPassword = '';

  vm.close = () => {
    $modalInstance.close();
  };

  vm.changePassword = () => {
    let data: ChangePasswordData = {
      id: vm.userProfile.id,
      oldPassword: vm.oldPassword,
      password: vm.newPassword,
      passwordConfirm: vm.confirmPassword
    };

    loaderService.loadingPromise(
      changePwdService.changePassword(data).then(() => {
        notifyService.success('Password Changed', 'User Profile');
        $modalInstance.close();
      }, notifyService.handleApiErrors)
    );
  };

  return vm;
}



// WEBPACK FOOTER //
// ./src/app/controllers/userProfile/changeUserPassword.controller.ts